// TODO: split it into separate files

export enum FeedVisibility {
  User = 'My Posts',
  Team = 'Team Posts',
  All = 'All Posts',
}
